module.exports = __webpack_public_path__ + "media/images/icons/google-5e7882c6b8f5959c390f1cf44e20fd11.svg";